var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.81 13.29.018l1.178 1.179-6.97 6.97-6.97-6.97L1.708.018 7.499 5.81Z",
    fill: "#602BE9"
  })));
};
export { SvgArrowDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDE1IDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik03LjQ5OTMgNS44MDk5OEwxMy4yOTEgMC4wMTgzMTA1TDE0LjQ2OTMgMS4xOTY2NEw3LjQ5OTMgOC4xNjY2NEwwLjUyOTI5NyAxLjE5NjY0TDEuNzA3NjMgMC4wMTgzMTA1TDcuNDk5MyA1LjgwOTk4WiIgZmlsbD0iIzYwMkJFOSIvPgo8L3N2Zz4K";